import { useState } from 'react'
import styles from './PasswordChangeModal.module.scss'
import { ExclamationCircleIcon } from '@heroicons/react/20/solid'
import { InputField } from '../fields/InputField/InputField'
import ValidationMap from '../../pages/signup/FirstSignup/components/BasicField/ValidationMap'
import { FormProvider, useFormContext, useWatch } from 'react-hook-form'
import { updatePassword } from '../../services/api'
import { useToken } from '../../utils/auth'

export const PasswordChangeModal = ({ isOpen, onClose, onSubmit: propOnSubmit }) => {
	const methods = useFormContext()
	const { handleSubmit, getValues } = methods
	const token = useToken()

	const [errorMsg, setErrorMsg] = useState('')
	const [isLoading, setIsLoading] = useState(false)

	const [password, confirmPassword] = useWatch({
		control: methods.control,
		name: ['password', 'confirmPassword'],
	})
	const isMatching = Boolean(password) && Boolean(confirmPassword) && password === confirmPassword

	const handlePasswordSubmit = async (data) => {
		if (!isMatching) {
			setErrorMsg('새 비밀번호와 비밀번호 확인이 일치하지 않습니다.')
			return
		}

		setIsLoading(true)
		setErrorMsg('')

		try {
			// propOnSubmit이 있으면 (비밀번호 찾기 플로우: /users/reset-password API 사용)
			// propOnSubmit에서 직접 API 호출하므로 여기서는 propOnSubmit만 실행
			if (propOnSubmit) {
				await propOnSubmit(data)
				onClose()
			} else if (token) {
				// 로그인된 사용자의 비밀번호 변경 (기본 정보 수정 플로우)
				// updatePassword API 사용 (token 필요)
				await updatePassword(token, data.password)
				onClose()
			} else {
				setErrorMsg('비밀번호 변경에 필요한 인증 정보가 없습니다.')
			}
		} catch (error) {
			console.error('비밀번호 변경 실패:', error)
			const errorMessage =
				error?.response?.data?.message ||
				error?.response?.data?.error ||
				error?.message ||
				'비밀번호 변경에 실패했습니다.'
			setErrorMsg(errorMessage)
		} finally {
			setIsLoading(false)
		}
	}

	if (!isOpen) return null
	return (
		<FormProvider {...methods}>
			<div className={styles.overlayStyle}>
				<div className={styles.modalStyle}>
					<h2 className={styles.title}>비밀번호 재설정</h2>

					<form onSubmit={handleSubmit} style={{ width: '100%' }}>
						<div className={styles.passwordChangeBox}>
							<InputField
								name="password"
								type="password"
								label="새 비밀번호"
								placeholder="새 비밀번호를 입력해주세요"
								validation={ValidationMap.password}
							/>
							<InputField
								name="confirmPassword"
								type="password"
								label="비밀번호 확인"
								placeholder="같은 비밀번호를 입력해주세요"
								validation={ValidationMap.password}
							/>
							{/*<input
							className={styles.inputPassword}
							type="password"
							placeholder="새 비밀번호를 입력해주세요"
							value={newPassword}
							onChange={(e) => setNewPassword(e.target.value)}
							required
						/>*/}
							{errorMsg && (
								<div className={styles.errorBanner}>
									<ExclamationCircleIcon
										style={{ width: '18px', height: '18px', color: '#ff5d5d' }}
									/>
									{errorMsg}
								</div>
							)}
						</div>
						<div className={styles.buttonBox}>
							<button
								className={styles.cancelButton}
								type="button"
								onClick={onClose}
								style={{ marginRight: '8px' }}>
								닫기
							</button>
							<button
								className={styles.completeButton}
								type="submit"
								onClick={handleSubmit(handlePasswordSubmit)}
								style={{
									backgroundColor:
										isMatching && !isLoading ? '#1b1b1b' : '#e4e4e4',
								}}
								disabled={!isMatching || isLoading}>
								{isLoading ? '처리중...' : '완료'}
							</button>
						</div>
					</form>
				</div>
			</div>
		</FormProvider>
	)
}
